import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import CourtReview from '../../entities/booking/courtReview';

interface CourtReviewState extends ListState<CourtReview>{
    editCourtReview:CourtReview
}
class CourtReviewMutations extends ListMutations<CourtReview>{

}
class CourtReviewModule extends ListModule<CourtReviewState,any,CourtReview>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<CourtReview>(),
        loading:false,
        editCourtReview:new CourtReview()
    }
    actions={
        async getAll(context:ActionContext<CourtReviewState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/CourtReview/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<CourtReview>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<CourtReviewState,any>,payload:any){
            await Ajax.post('/api/services/app/CourtReview/Create',payload.data);
        },
        async createWithImages(context:ActionContext<CourtReviewState,any>,payload:any){
            await Ajax.post('/api/services/app/CourtReview/CreateWithImages',payload.data);
        },
        async update(context:ActionContext<CourtReviewState,any>,payload:any){
            await Ajax.put('/api/services/app/CourtReview/Update',payload.data);
        },
        async updateWithImages(context:ActionContext<CourtReviewState,any>,payload:any){
            await Ajax.put('/api/services/app/CourtReview/UpdateWithImages',payload.data);
        },
        async delete(context:ActionContext<CourtReviewState,any>,payload:any){
            await Ajax.delete('/api/services/app/CourtReview/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<CourtReviewState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/CourtReview/Get?Id='+payload.id);
            return reponse.data.result as CourtReview;
        }
    };
    mutations={
        setCurrentPage(state:CourtReviewState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CourtReviewState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:CourtReviewState,courtReview:CourtReview){
            state.editCourtReview=courtReview;
        }
    }
}
const courtReviewModule=new CourtReviewModule();
export default courtReviewModule;